import { api } from '@/plugins'
import {
  GET_PRIME_CONFIG,
  GET_PRIME_CONFIG_SUCCESS,
  GET_PRIME_CONFIG_FAIL
} from './mutations'

export default {
  listConfig({ commit }) {
    return new Promise((resolve, reject) => {
      commit(GET_PRIME_CONFIG)

      api
        .GET('production/primes/listConfig')
        .then(async (datas) => {
          await commit(GET_PRIME_CONFIG_SUCCESS, datas)
          resolve(datas)
        })
        .catch((e) => {
          commit(GET_PRIME_CONFIG_FAIL)
          reject(e)
        })
    })
  }
}
